import * as React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Modal } from "antd";

interface DownloadDocumentModalProps {
	visible: boolean;
}

export default ({ visible }: DownloadDocumentModalProps) => {
	return (
		<Modal
			visible={visible}
			title={
				<div>
					<LoadingOutlined className="mr-4" />
					Downloading
				</div>
			}
			centered={true}
			keyboard={false}
			closable={false}
			footer={null}
		>
			Downloading your file
		</Modal>
	);
};
